import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import CurrentFBO from '../../Services/CurrentFBO';

const DEFAULT_TITLE = 'Huvercraft';
const DEFAULT_LOGO_URL = 'https://ci-app.huvercraft.com/static/media/huvercraft-logo.ef8a4051.svg';
class Header extends Component {
  // static propTypes = {
  //   location: React.PropTypes.object.isRequired
  // }
  constructor(props) {
    super(props);

    this.state = {
      fboName: '',
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  async fetchData() {
    try {
      const fbo = await CurrentFBO.get();
      this.setState({ fboName: fbo.name, logoUrl: fbo.logoUrl });
    } catch (error) {
      console.log(error);
      this.setState({ fboName: DEFAULT_TITLE, logoUrl: DEFAULT_LOGO_URL });
    }
  }

  render() {
    return (

      <Link
        to="/orders"
        href="/orders"
        className="fbo-logo"
        style={{ background: `url(${this.state.logoUrl}) center center no-repeat` }}
      >
        <h1 title="Home">{ this.state.fboName }</h1>
      </Link>

    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js